var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"item-name"},[_vm._v(_vm._s(_vm.initComponent.name))]),_vm._v(" "),_c('div',{staticClass:"component-content"},[_c('el-input',{class:{onlyread:_vm.component.properties.readonly},attrs:{"disabled":""}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b259d018","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/components/login-user/rc-login-user.vue
// module id = null
// module chunks = 